import React, { useState } from 'react';

const CORRECT_PASSWORD = '0000411637'; 

const SciFiLockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 24 24" fill="none" stroke="#38bdf8" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0 0 10px rgba(56,189,248,0.6))', marginBottom: '15px' }}>
        <circle cx="12" cy="12" r="10" strokeOpacity="0.4"></circle>
        <circle cx="12" cy="12" r="6" strokeOpacity="0.7"></circle>
        <circle cx="12" cy="12" r="2" fill="#38bdf8"></circle>
        <path d="M12 2v4M12 18v4M2 12h4M18 12h4" strokeOpacity="0.5"></path>
        <path d="M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" strokeOpacity="0.3"></path>
    </svg>
);

// YENİ CSS BAZLI LOGO
const CustomLogo = () => (
    <div style={{ textAlign: 'center', lineHeight: '1.2', marginBottom: '1.5rem', userSelect: 'none' }}>
        <div style={{ fontFamily: '"Arial Black", Impact, sans-serif', fontWeight: '900', fontSize: '2.2rem', color: '#ffffff', letterSpacing: '4px', textTransform: 'uppercase', textShadow: '0 0 10px #38bdf8, 0 0 20px #0284c7' }}>
            GUNES SPACE
        </div>
        <div style={{ fontFamily: 'monospace', fontSize: '0.75rem', color: '#7dd3fc', letterSpacing: '6px', textTransform: 'uppercase', marginTop: '2px', opacity: '0.8' }}>
            Kozmİk Fİlo - H. ALİ KARA
        </div>
    </div>
);

const LoginScreen = ({ onLoginSuccess }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === CORRECT_PASSWORD) {
            setError('');
            onLoginSuccess();
        } else {
            setError('ERİŞİM REDDEDİLDİ! Hatalı güvenlik kodu.');
            setPassword('');
        }
    };

    const styles = {
        container: {
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            minHeight: '100vh', background: 'radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%)', 
            padding: '20px', fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif'
        },
        card: {
            padding: '3.5rem 2.5rem', borderRadius: '20px', backgroundColor: 'rgba(15, 23, 42, 0.65)', 
            backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.6), inset 0 0 0 1px rgba(56, 189, 248, 0.15)',
            width: '100%', maxWidth: '420px', textAlign: 'center', position: 'relative', overflow: 'hidden'
        },
        logoArea: {
            marginBottom: '1.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
        },
        title: {
            marginBottom: '0.5rem', color: '#e0f2fe', fontWeight: '800', fontSize: '1.9rem',
            letterSpacing: '1px', textTransform: 'uppercase', textShadow: '0 0 15px rgba(56, 189, 248, 0.4)'
        },
        subtitle: { color: '#94a3b8', marginBottom: '2.5rem', fontSize: '0.95rem', letterSpacing: '0.5px' },
        inputWrapper: { position: 'relative', marginBottom: '1.5rem' },
        input: {
            width: '100%', padding: '1.1rem 1.2rem', border: isFocused ? '1px solid #38bdf8' : '1px solid #334155', 
            borderRadius: '12px', fontSize: '1rem', outline: 'none', transition: 'all 0.3s ease',
            backgroundColor: isFocused ? 'rgba(15, 23, 42, 0.9)' : 'rgba(30, 41, 59, 0.6)',
            color: '#38bdf8', letterSpacing: '2px', textAlign: 'center',
            boxShadow: isFocused ? '0 0 15px rgba(56, 189, 248, 0.2)' : 'none'
        },
        button: {
            width: '100%', padding: '1.1rem', border: 'none', borderRadius: '12px',
            background: 'linear-gradient(135deg, #0284c7 0%, #2563eb 100%)', color: '#ffffff',
            fontSize: '1.1rem', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase',
            cursor: 'pointer', transition: 'all 0.2s ease', boxShadow: '0 8px 20px rgba(37, 99, 235, 0.3)'
        },
        error: {
            color: '#fca5a5', marginTop: '1.5rem', minHeight: '1.2rem', fontSize: '0.85rem',
            fontWeight: '600', backgroundColor: 'rgba(127, 29, 29, 0.3)',
            border: error ? '1px solid rgba(248, 113, 113, 0.4)' : 'none',
            padding: error ? '10px' : '0', borderRadius: '8px', opacity: error ? 1 : 0,
            transition: 'all 0.3s ease', letterSpacing: '0.5px'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                
                <div style={styles.logoArea}>
                    <CustomLogo />
                    <SciFiLockIcon />
                </div>

                <h2 style={styles.title}>Komuta Merkezİ</h2>
                <p style={styles.subtitle}>Filonu yönetmek için erişim kodunu gir!</p>
                
                <form onSubmit={handleSubmit}>
                    <div style={styles.inputWrapper}>
                        <input
                            type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                            onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)}
                            placeholder="ERİŞİM KODU..." style={styles.input} autoFocus
                        />
                    </div>
                    
                    <button 
                        type="submit" style={styles.button}
                        onMouseOver={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 10px 25px rgba(56, 189, 248, 0.5)';
                            e.currentTarget.style.background = 'linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 8px 20px rgba(37, 99, 235, 0.3)';
                            e.currentTarget.style.background = 'linear-gradient(135deg, #0284c7 0%, #2563eb 100%)';
                        }}
                        onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.98)'}
                        onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                    >
                        Sistemi Başlat
                    </button>
                </form>
                
                <div style={styles.error}>{error}</div>
            </div>
        </div>
    );
};

export default LoginScreen;